export default __webpack_public_path__ + "static/media/service_point.6a441c39.svg";